<template>
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-form-box">
			<div class="logo">
				<img src="../assets/images/logo.png" alt="">
			</div>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            label-width="80px"
            :size="size"
			@submit.native.prevent 
			    @keyup.enter.native="login('loginForm')"
			label-position="top"
          >
            <el-form-item label="手机号码" prop="user_phone">
              <el-input v-model="loginForm.user_phone" placeholder="请填写手机号码"  @keyup.enter.native="login('loginForm')"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input show-password v-model="loginForm.password" placeholder="请填写登录密码" @keyup.enter.native="login('loginForm')"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="captcha">
				<div class="yzm">
					<div class="left">
						<el-input v-model="loginForm.captcha" placeholder="请填写验证码" @keyup.enter.native="login('loginForm')"></el-input>
					</div>
					<div class="right" @click="getVerify()">
					  <img :src="captchaImage" alt="验证码" width="100%" />
					  <!-- <el-image :src="captchaImage" alt="验证码" width="100%" /> -->
					</div>
				</div>
            </el-form-item>
            <div class="container-login100-form-btn">
              <el-button type="primary" @click="login('loginForm')">登 录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      loginForm: {
        user_phone: '',
        password: '',
        captcha: '',
		key:''
      },
      loginRules: {
        user_phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      captchaImage: '',
      size: 'big'
    }
  },
  beforeMount: function() {
    this.getVerify()
  },
  methods: {
    getVerify: function() {
      this.$api.get('/admin/verify/captcha/refresh').then(res => {
        // let blob = new Blob([res], { type: 'image/png' })
        // this.captchaImage = window.URL.createObjectURL(blob)
		this.captchaImage = res.image_url
		this.loginForm.key = res.key
      })
    },
    login: function(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.$api.post('/admin/users/login/login', this.loginForm).then(res => {
            if (res.code == 0) {
              localStorage.setItem('fy-token', res.msg)
              // 强制刷新页面，确保 Layout.vue 的 mounted 钩子重新执行
              window.location.href = '/'
            } else {
              this.$message.error(res.msg);
              this.getVerify()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container-login100 {
  background: url(../assets/images/login.jpg) no-repeat center;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: relative;
}

.wrap-login100 {
	width: 418px;
	overflow: hidden;
	position: absolute;
	padding:37px 90px 54px;
	box-sizing: border-box;
	left: 50%;
	top: 48%;
	background: rgba(255,255,255,0.5);
	border-radius: 20px;
	border: 2px solid #F2FBFE;
	transform: translate(30%, -50%);
	-ms-transform: translate(30%, -50%);
	-moz-transform: translate(30%, -50%);
	-webkit-transform: translate(30%, -50%);
	-o-transform: translate(30%, -50%);
}

.login100-form-title {
  width: 100%;
  position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  padding: 70px 15px 74px 15px;
  background: url(../assets/images/bg-01.jpg);
}
.container-login100-form-btn {
  text-align: center;
}
.el-button{
	width: 100%;
	border: none;
	height: 36px;
	background: #367CFF;
	border-radius: 5px;
}
.yzm{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.left{
	flex: 1;
	margin-right: 10px;
}
.right{
	width: 70px;
	height: 33px;
	overflow: hidden;
	border: 1px solid #CDE5FB;
	border-radius: 2px;
}
.logo{
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 20px;
}
.logo img{
	width: 140px;
}
</style>